import { formatDistance, formatElev } from "../lib/track-utils";
import { useLang } from "../contexts/LanguageContext";

export default function StatsBar({ stats }) {
    const { t } = useLang();
    const {
        distance,
        roundtrip,
        altMax,
        altMin,
        climb,
        descent,
        pointsCount,
        poiCount,
        unpavedPct,
        unpavedDist,
    } = stats;

    return (
        <div
            className="rf-card grain relative flex items-stretch overflow-x-auto"
            data-testid="stats-bar"
            style={{ padding: "4px 4px" }}
        >
            <div className="stat-tile" data-testid="stat-distance">
                <span className="stat-label">{t("distance")}</span>
                <span className="stat-value accent font-mono-stat">
                    {formatDistance(distance)}
                </span>
            </div>
            <div className="stat-tile" data-testid="stat-roundtrip">
                <span className="stat-label">{t("roundtrip")}</span>
                <span className="stat-value font-mono-stat">
                    {formatDistance(roundtrip)}
                </span>
            </div>
            <div className="stat-tile" data-testid="stat-altmax">
                <span className="stat-label">{t("altMax")}</span>
                <span className="stat-value font-mono-stat">
                    {formatElev(altMax)}
                </span>
            </div>
            <div className="stat-tile" data-testid="stat-altmin">
                <span className="stat-label">{t("altMin")}</span>
                <span className="stat-value font-mono-stat">
                    {formatElev(altMin)}
                </span>
            </div>
            <div className="stat-tile" data-testid="stat-climb">
                <span className="stat-label">{t("climb")}</span>
                <span className="stat-value up font-mono-stat">
                    {formatElev(climb)}
                </span>
            </div>
            <div className="stat-tile" data-testid="stat-descent">
                <span className="stat-label">{t("descent")}</span>
                <span className="stat-value down font-mono-stat">
                    {formatElev(descent)}
                </span>
            </div>
            <div className="stat-tile" data-testid="stat-points">
                <span className="stat-label">{t("points")}</span>
                <span className="stat-value font-mono-stat">
                    {pointsCount}
                </span>
            </div>
            <div className="stat-tile" data-testid="stat-poi">
                <span className="stat-label">{t("pois")}</span>
                <span className="stat-value font-mono-stat">{poiCount}</span>
            </div>
            {typeof unpavedPct === "number" && (
                <div className="stat-tile" data-testid="stat-unpaved">
                    <span className="stat-label">{t("unpaved")}</span>
                    <span
                        className="stat-value font-mono-stat"
                        style={{ color: "#ff7a18" }}
                    >
                        {Math.round(unpavedPct)}%
                        <span className="text-[10px] text-[var(--text-faint)] ml-1">
                            ({formatDistance(unpavedDist)})
                        </span>
                    </span>
                </div>
            )}
        </div>
    );
}
